import {
   AfterViewInit,
   Component,
   ElementRef,
   EventEmitter,
   Input,
   NgZone,
   OnChanges,
   OnDestroy,
   Output,
   ViewChild
} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Router} from '@angular/router';

import {Observable, Subject} from 'rxjs';

import {TranslateService} from '@ngx-translate/core';
import WebViewer, {Core, UI, WebViewerInstance, WebViewerOptions} from '@pdftron/webviewer';

import {environment} from '../../../environments/environment';
import {ConfirmDialogComponent} from '../../e-signature/confirm-dialog/confirm-dialog.component';
import {IdexService} from '../../idex.service';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {getFileExtension} from '../../shared/helper-functions';
import {Toast} from '../../shared/toast/toast';
import {AnnotationAttributes, WatermarkDMS} from '../../shared/types';
import {DocListComponent} from '../doclist/doclist.component';
import {FileUploader} from '../file-uploader';
import {UploadProgressComponent} from '../upload-progress/upload-progress.component';
import {AnnotationControllerService} from './annotation-controller.service';
import {DocumentData} from './document-data.type';
import {ActionButton} from './models/action-button.model';
import {ThemeMode} from './services/change-theme-mode.service';
import {setWatermarkOptions} from './services/set-watermark.service';
import { PdfTemplateListDialogComponent } from 'app/admin/pdf-template-list-dialog/pdf-template-list-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
declare const isSaveAnnotation: boolean;


@Component({
   selector: 'app-sign-pdftron',
   templateUrl: './annotation-controller.component.html',
   styleUrls: ['./annotation-controller.component.css']
})
export class AnnotationControllerComponent implements AfterViewInit, OnDestroy, OnChanges {

   @ViewChild(AppLoaderComponent, { static: true }) loader: AppLoaderComponent;
   @ViewChild('viewer') viewerRef: ElementRef;
   @Input() documentData: DocumentData;
   @ViewChild('progress') progress: UploadProgressComponent;
   @ViewChild(DocListComponent, { static: true }) docList: DocListComponent;
   @Output() openNotesPanel = new EventEmitter();
   @Output() switchViewer = new EventEmitter();
   @Input() tempId: string;
   @Input() checkNotSave: any;
   onClose: EventEmitter<boolean> = new EventEmitter();
   typeName: string;
   flagOpenDialog: boolean = false;
   fileDocs: File;
   fileMerge: File;
   fileXml: File;
   isCheckHideSaveBtnXml = false;
   isCheckHideSaveBtnDoc = false;
   isCheckHideSaveBtnDocLine = false;
   isRotated = false;
   isRotatedLine = false;
   annotationId: string;
   annotationVersion: string;
   isCloseBtnOnBack = true;
   docAnnotationId: number;
   isStartFlow = false;
   isSaveDoc = false;
   isUpdate = false;
   isInsert = false;
   saveDoc = false;
   isUpdateOnClose = false;
   fileUpload: any;
   chunkSize = 1048576;
   isCheckViewOnly = false;
   isCheckComment = false;
   isCheckSaveBtn = false;
   isCheckSaveOnBack = false;
   isFlagCloseCanDe = true;
   isTask = false;
   firstAnnotationSize = 0;
   checkAnnotationSize = 0;
   createdBy: string;
   countSwitch = 0;
   checkSaveOnStartFlow = false;
   originalRotation = [];
   rotationUpdated = false;
   imageView: boolean = false;
   checkRotated: boolean = false;
   isNavigateToCreateTask: boolean = false;
   isCreateTask: boolean = false;
   callbackCreateTask: any;
   flagNoMsg: boolean = false;
   unsaveTemplate$: Subject<string>;
   pdfTemplateListDialog: MatDialogRef<PdfTemplateListDialogComponent>;
   loading = false;

   // Check the last divider element inside PDFTron Menu Overlay
   private lastDividerObserver: MutationObserver;

   constructor(
      public uploader: FileUploader,
      protected service: IdexService,
      public toast: Toast,
      public dialog: MatDialog,
      protected translate: TranslateService,
      protected zone: NgZone,
      private router: Router,
      private annoService: AnnotationControllerService
   ) {
   }

   paths: any[];
   private readonly limitSize = 10485760;
   public tin: string;
   selectedItems: any[] = [];
   doc: any;
   public files = [];
   public doclist = {
      docId: '',
      docName: '',
      totalPages: '',
      signItems: []
   };
   private saveXml = false;
   private saveDocs = false;
   private webViewerInstance: WebViewerInstance;

   dataWaterMark: WatermarkDMS;
   flagCheckFirst = true;
   showAddPageBtn = true;
   isShowSaveBtn = false;
   showAddTemplateBtn = true;
   pageCounted: number;
   annotationList: Core.Annotations.Annotation[];

   count = 0;
   isActionCount = 0;
   allCommentAnno = {}; // เอาไว้เก็บ Anno ที่มี comment
   firstCommentAnno = {}; // เอาไว้เก็บชื่อ user ของ anno ทุกตัว เพื่อไล่หา email
   checkFlagComment = true; // เป็น flag เอาไว้นับจำนวน anno ที่มี comment ตอนเปิดเอกสาร
   copyAllCommentAnno = []; // เอามา copy แยก comment หลังเช็คว่า empty ไหม
   copyFirstCommentName = []; // เอาไว้เก็บ email หลังเช็คว่า empty ไหม
   checkCommentFirst = 0; // เอาไว้ check ว่า user ทำ comment ไว้กี่อัน
   countComment = 0;
   checkActionAdd = false;
   firstTimeCountAnno = 0;
   checkFirstTime = true;
   flagAnno = false;
   myFiles = "My Files";

   ngOnChanges() {
      if (this.documentData.actionType === 'switch') {
         if (this.checkNotSave === 'notSave') {
            this.loader.hide();
            this.webViewerInstance?.Core.documentViewer.zoomTo(1);
         }
      }
   }

   /**
    * This variable is for storing our custom buttons to be added to PDFTrons MenuOverlay.
    */
   private MenuOverlay: object[] = [];

   ngAfterViewInit(): void {
      this.annoService.documentData = this.documentData;
      if (this.countSwitch === 0 && this.documentData.actionType === 'switch') {
         this.translate.get('removed-from').subscribe(s => {
            this.toast.warn(s);
         });
      }
      if (this.documentData.actionType === 'task' || this.documentData.actionType === 'switch') {
         this.isTask = true;
      }
      const mimeType: string = this.documentData.mimeType;
      const fileName: string = this.documentData.fileName;
      const extension: string = this.documentData.fileFormat || getFileExtension(fileName);
      const documentURL: string = this.documentData.url;

      let webViewerOptions: WebViewerOptions = {
         licenseKey: environment.pdfTronKey.toString(),
         path: '../assets/lib',
         fullAPI: true,
         selectAnnotationOnCreation: true,
         enableAnnotations: true,
         filename: this.documentData.fileName,
         disabledElements: ["settingsButton"],
      };

      if (documentURL.includes("share-public")) {
         //| ZE-2613: view-share, share-public cannot open watermark PDF due to PDFTrons
         //| Downloader uses Bytes range request to download linearized PDF, but our server
         //| does NOT support Bytes range request for watermark PDF. Thus, disabling it.
         //|____________________________________________________________________________
         webViewerOptions.useDownloader = false;
      }

      if (mimeType === 'image/jpeg' || mimeType === 'image/png') {
         this.loadImageType(webViewerOptions, documentURL, fileName);
      } else if (mimeType === 'image/tiff') {
         this.loadTiffType(webViewerOptions, documentURL);
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
         mimeType === 'application/vnd.ms-powerpoint'||
         mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'||
         mimeType === 'application/msword'||
         mimeType === 'application/vnd.ms-excel'||
         mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
         mimeType === 'application/vnd.oasis.opendocument.text') {
         this.loadOfficeType(webViewerOptions, documentURL, fileName, extension);
      } else {
         this.loadPdfType(webViewerOptions, documentURL);
      }
   }
// End ngAfterViewInit()
    private loadPdfType(webViewerOptions: WebViewerOptions, documentURL: string) {
        webViewerOptions.initialDoc = `${documentURL}`;
        webViewerOptions.loadAsPDF = true;
        WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            this.webViewerInstance = instance;
            this.setInstanceFactory(instance);
            this.checkTimeOut();
            const PDFNet = instance.Core.PDFNet;
            await PDFNet.runWithCleanup(async () => {
                try {
                    const securedDoc = await PDFNet.PDFDoc.createFromURL(documentURL);
                    if (!(await securedDoc.initSecurityHandler())) {
                        document.getElementById('app-loader').style.display = 'none';
                    }
                } catch (e) {
                } finally {
                    this.loader.hide();
                }
            }, environment.pdfTronKey.toString()).then(() => {
                this.loader.hide();
            });
        });
    }
    private loadOfficeType(webViewerOptions: WebViewerOptions, documentURL: string, fileName: string, extension: string) {
        WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            try {
                const doc = await instance.Core.createDocument(documentURL, {
                    filename: fileName,
                    extension: extension,
                });
                instance.UI.loadDocument(doc);
                this.webViewerInstance = instance;
                this.setInstanceFactory(instance);
            } catch (e) {
                // TODO: Add failsafe in case that the file cannot be opened. For example, when the file is corrupted.
                console.error(e);
            } finally {
                this.loader.hide();
            }
            this.checkTimeOut();
        });
    }
    private loadTiffType(webViewerOptions: WebViewerOptions, documentURL: string) {
        WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            this.webViewerInstance = instance;
            this.setInstanceFactory(instance);
            this.checkTimeOut();
            const PDFNet = instance.Core.PDFNet;
            this.loader.show();

            let newDoc: Core.PDFNet.PDFDoc;
            await PDFNet.runWithoutCleanup(async () => {
                // create an empty document
                newDoc = await PDFNet.PDFDoc.create();
                await newDoc.initSecurityHandler();
                await newDoc.lock();
                const tiffFile = await PDFNet.Filter.createURLFilter(documentURL);
                await PDFNet.Convert.fromTiff(newDoc, tiffFile);
                await newDoc.unlock();
                instance.UI.loadDocument(newDoc);
            }, environment.pdfTronKey.toString());

            this.loader.hide();
        });
    }
    private loadImageType(webViewerOptions: WebViewerOptions, documentURL: string, fileName: string) {
        webViewerOptions.loadAsPDF = true;
        this.imageView = true;
        WebViewer(webViewerOptions, this.viewerRef.nativeElement).then(async instance => {
            instance.UI.loadDocument(documentURL, {filename: fileName});
            this.webViewerInstance = instance;
            this.setInstanceFactory(instance);
            this.checkTimeOut();
        });
    }

   async changeDoc(data: any) {
      this.documentData = data;
      const documentURL: string = this.documentData.url;
      const fileName: string = this.documentData.fileName;
      const doc = await this.webViewerInstance.Core.createDocument(documentURL);
      this.webViewerInstance.UI.loadDocument(doc, { filename: fileName });
      if (this.documentData.mimeType === 'image/jpeg' || this.documentData.mimeType === 'image/png') {
         this.imageView = true;
      } else {
         this.imageView = false;
         this.unViewOnly(this.webViewerInstance);
         this.loader.hide();
      }
      const { Core } = this.webViewerInstance;
      const { documentViewer } = Core;
      const annotMana = documentViewer.getAnnotationManager();
      this.changeInstance(this.webViewerInstance, annotMana);
   }

   changeInstance(instance: WebViewerInstance, annotMana: Core.AnnotationManager) {
      this.showAddPageBtn = this.isMimeTypeCompatibleForAddPage(this.documentData.mimeType);
      this.showAddTemplateBtn = this.isMimeTypeCompatibleForAddTemplate(this.documentData.mimeType);
      this.checkStatusViewOnly(instance);
      if (this.documentData.actionType === 'switchTask'
         || (this.documentData.actionType === 'switch' && this.imageView)) {
            if(this.documentData.mimeType.split('/')[0] != 'image') {
               if (this.documentData.actionType === 'switchTask') { // ZE-3437 set view only
                  this.showAddPageBtn = false;
                  this.showAddTemplateBtn = false;
                  this.isCheckHideSaveBtnXml = false;
                  this.isCheckHideSaveBtnDoc = false;
                  this.isRotated = false;
                  this.setViewOnly(instance);
                  this.loader.hide();
               } else {
                  this.unViewOnly(instance);
                  this.loader.hide();
               }
            } else {
               this.showAddPageBtn = false;
               this.showAddTemplateBtn = false;
               this.isCheckHideSaveBtnXml = false;
               this.isCheckHideSaveBtnDoc = false;
               this.isRotated = false;
               this.setViewOnly(instance);
               this.loader.hide();
            }
      }

      if (this.documentData.statusDocument === 'Completed') {
         this.isStartFlow = false;
      }

      if (this.documentData.isPermissions?.delete) {
          // can delete สามารถเพิ่ม, แก้ไข, ขยับ และลบ annotation ได้ทั้งของตัวเองและของคนอื่น
          annotMana.promoteUserToAdmin();
      } else if (this.documentData.isPermissions?.write) {
          // can edit เพิ่ม Anno ได้ทุกอย่าง แต่ ลบหรือแก้ไข ของคนอื่นไม่ได้
         annotMana.setPermissionCheckCallback((author) => {
            return author.split('(')[1].split(')')[0] === this.service.user.email;
         });
      } else if (this.documentData.isPermissions?.create) {
         // can comment
          this.hideFunctions(instance);
          this.isCheckComment = true;
          this.showAddPageBtn = false;
          this.showAddTemplateBtn = false;
         annotMana.setPermissionCheckCallback((author) => {
             return author.split('(')[1].split(')')[0] === this.service.user.email;
         });
       } else {
         // can view
         this.showAddPageBtn = false;
         this.showAddTemplateBtn = false;
         this.isCheckHideSaveBtnXml = false;
         this.isCheckHideSaveBtnDoc = false;
         this.isRotated = false;
         this.setViewOnly(instance);
      }
   }
   /**
    * PDFTron WebViewer Controller
    */
   private setInstanceFactory(instance: WebViewerInstance) {
      this.isActionCount = 0;
      this.flagCheckFirst = true;
      this.count = 0;
      this.showAddPageBtn = true;
      this.showAddTemplateBtn = true;
      this.isShowSaveBtn = false;
      this.loader.show(); // Loader will hide at `documentViewer.addEventListener('pageComplete', ...`
      this.annoService.loader = this.loader;
      this.isCloseBtnOnBack = true;
      this.isCheckHideSaveBtnXml = false;
      this.isCheckHideSaveBtnDoc = false;
      this.isCheckHideSaveBtnDocLine = false;
      this.isRotated = false;
      this.isRotatedLine = false;
      this.allCommentAnno = {}; // เอาไว้เก็บ Anno ที่มี comment
      this.firstCommentAnno = {}; // เอาไว้เก็บชื่อ user ของ anno ทุกตัว เพื่อไล่หา email
      this.checkFlagComment = true; // เป็น flag เอาไว้นับจำนวน anno ที่มี comment ตอนเปิดเอกสาร
      this.copyAllCommentAnno = []; // เอามา copy แยก comment หลังเช็คว่า empty ไหม
      this.copyFirstCommentName = []; // เอาไว้เก็บ email หลังเช็คว่า empty ไหม
      this.checkCommentFirst = 0; // เอาไว้ check ว่า user ทำ comment ไว้กี่อัน
      this.countComment = 0;
      this.checkActionAdd = false;
      const { Core, UI } = instance;
      const { documentViewer } = Core;
      const annotMana = documentViewer.getAnnotationManager();

      this.annoService.instance = instance;

      if (isSaveAnnotation) {
         this.typeName = 'annotation';
      } else {
         this.typeName = 'pdftron';
      }
      this.dataWaterMark = this.documentData.watermark;
      if (this.documentData.statusStartFlow) {
         this.isStartFlow = this.documentData.statusStartFlow && this.documentData.statusDocument !== 'Completed';
      } else {
         this.isStartFlow = false;
      }

      if (this.dataWaterMark !== null && this.dataWaterMark !== undefined) {
         setWatermarkOptions(instance, this.dataWaterMark);
      }

      UI.closeElements(['toolsOverlay']);
      // set default ตาม ZE-1740
      UI.setToolbarGroup('toolbarGroup-View', true);
      // ปิดไปก่อนตามการ์ด https://ginkgosoft.atlassian.net/browse/ZE-2564
      // ปิดตามการ์ด https://ginkgosoft.atlassian.net/browse/ZE-3134
      UI.disableElements(['languageButton', 'signatureToolGroupButton', 'signatureFieldToolGroupButton', 'arcToolGroupButton','richTextPopup']);

      UI.addEventListener('toolbarGroupChanged', async (e: CustomEvent) => {
         const group = e.detail;
         if (group === 'toolbarGroup-Forms') {
            const annotationManager = Core.annotationManager;
            const annots =  annotationManager.getAnnotationsList();
            annots.forEach(a => {
               annotationManager.showAnnotation(a);
               annotationManager.redrawAnnotation(a);
            });
         } 
      });

      //=============================================================================
      // Update Theme of Each Custom Button's Icon
      //=============================================================================
      // PDFTron WebViewer now remembers the user's settings. If the user previously
      // select 'Dark Mode', WebViewer will start in Dark Mode the next time too.
      //
      // When the user changes theme mode, our custom icons will not be updated and
      // continue to use the default light mode icons.
      //
      // Thus, icons of each button are updated here.
      //=============================================================================
      this.annoService.updateIconPathsForTheme(this.annoService.getThemeMode(instance));
      this.updateButtonTheme();

      this.changeInstance(instance, annotMana);

      // If no user token, assume the user is a guest from view-share-public
      if (!this.service.user?.token) {
         this.showAddPageBtn = false;
         this.showAddTemplateBtn = false;
         this.isCheckHideSaveBtnXml = false;
         this.isCheckHideSaveBtnDoc = false;
         this.isRotated = false;
         this.setViewOnly(instance);
      }
      this.checkStatusViewOnly(instance);
      // Add custom buttons to show in Menu Overlay (gear icon)
      if (this.documentData.isPermissions?.print || this.documentData.allowDownloadAndPrint) {
         this.MenuOverlay.push(this.Buttons["Print"], this.Buttons["Download"]);
      }
      this.MenuOverlay.push(this.Buttons["ChangeThemeMode"]);

      UI.settingsMenuOverlay.update(this.MenuOverlay);

      this.hideLastDividerInMenuOverlay();

      UI.setHeaderItems((header) => this.pushCustomButtonsToHeader(header));



      // set fit mode
      const fitMode = UI.FitMode;
      UI.setFitMode(fitMode.Zoom);
      const lang = localStorage.getItem('lang') || 'en';

      annotMana.addEventListener('fieldChanged', (value) => {
         this.isCheckHideSaveBtnXml = true;
         this.isCloseBtnOnBack = false;
         this.checkAnnotationSize++;
         if (value) {
            UI?.enableElements([this.Buttons["Save"].dataElement]);
            localStorage.setItem('onChanged', 'true');
         }
         this.setSaveBtn();
      });

      documentViewer.addEventListener('documentLoaded', async () => {
      this.annoService.setPdftronOpened(true);
         await documentViewer.getDocument().getDocumentCompletePromise();
         documentViewer.zoomTo(1);
         if (this.checkRotated) {
            UI?.disableElements([this.Buttons["Save"].dataElement]);
            UI.toggleElementVisibility('leftPanel');
            this.checkRotated = false;
         }
         this.pageCounted = documentViewer.getPageCount();
         this.firstAnnotationSize = 0;
         this.checkAnnotationSize = 0;
         for (let i = 1 ; i <= this.pageCounted ; i++) {
            this.originalRotation[i] = documentViewer.getCompleteRotation(i);
         }
         // https://ginkgosoft.atlassian.net/browse/ZE-3149
         if (lang === 'en') {
            await UI.setLanguage(UI.Languages.EN);
         } else if (lang === 'th'){
            await UI.setLanguage(UI.Languages.TH);
         } else if (lang === 'cn') {
            await UI.setLanguage(UI.Languages.ZH_CN);
         }

         if (!isSaveAnnotation) {
            annotMana.setCurrentUser(this.service.user.name);
            return;
         }

         //| Send GET request to retrieve annotation's Metadata/attributes of this docId
         //|
         //|   By converting Observable to Promise, it guarantees to finish retrieving and
         //| updating annotation attributes before retrieving annotation contents.
         //| See ZE-2569 for details.
         //|_____________________________________________________________________________________
         this.annotationId = '';
         this.annotationVersion = '';
         let annotationAttributes: AnnotationAttributes;
         if (this.documentData.docId) {
            try {
               annotationAttributes = await this.service.getAnnotation(this.documentData.docId, true)?.toPromise();
            } catch (err) {
               console.error('Failed to retrieve annotation attributes', err);
            }

            //| Update various shared variables (annotation's attributes)
            //|_____________________________________________________________________________________
            if (annotationAttributes) {
               this.annotationVersion = annotationAttributes.annotationVersion;
               this.annotationId = annotationAttributes.annotationId;
               this.docAnnotationId = annotationAttributes.docAnnotationId;
               this.createdBy = annotationAttributes.createdBy;
               if (this.service.user?.email != null) {
                  // ดึงชื่อ user ที่ตรงกับ database
                  annotMana.setCurrentUser(this.service.user.name + ' (' + this.service.user.email + ')');
               }

               //| Send GET request to retrieve annotation content
               //|_____________________________________________________________________________________
               if (!this.documentData.statusDocument || this.documentData.statusDocument === 'Draft') {
                  this.service.getContentAnnotation(this.annotationId, this.annotationVersion).subscribe(annotationContent => {
                  // ถ้า checkUploadNewVersion != null คือ uploadNewVersion ผ่านการ include anno เท่านั้น
                     if (
                        this.documentData.lastDocVersion === annotationAttributes.docVersion ||
                        (this.documentData.actionType === 'switch')
                     ) {
                        annotMana.importAnnotations(annotationContent);
                     }
                  });
               }
               return;
            } else {
               this.service.getAnnotation(this.documentData.docId, true).subscribe(
                  lastAnnotation => {
                     if (lastAnnotation) {
                        this.annotationVersion = lastAnnotation.annotationVersion;
                        this.annotationId = lastAnnotation.annotationId;
                        this.docAnnotationId = lastAnnotation.docAnnotationId;
                        this.createdBy = lastAnnotation.createdBy;
                     }
                  },
                  err => {
                     console.error('Failed to retrieve annotation attributes', err);
                  }
               );
            }
         }

         if (this.service.user) {
            // ดึงชื่อ user ที่ login
            annotMana.setCurrentUser(this.service.user.name + ' (' + this.service.user.email + ')');
         }
      });

      UI.updateElement('thumbDelete', {
         onClick: () => {
            this.deletePage();
            this.setSaveBtn();
            documentViewer.refreshAll();
         }
      });

      UI.updateElement('thumbMultiDelete', {
         onClick: () => {
            this.deletePage();
            this.setSaveBtn();
            documentViewer.refreshAll();
         }
      });

      UI.updateElement('thumbRotateCounterClockwise', {
         onClick: () => {
            this.reLoadPage(UI, this.documentData);
            this.rotatePage('counterClockwise');
         }
      });

      UI.updateElement('thumbRotateClockwise', {
         onClick: () => {
            this.reLoadPage(UI, this.documentData);
            this.rotatePage('clockwise');
         }
      });

      UI.updateElement('thumbMultiRotate', {
         onClick: () => {
            this.reLoadPage(UI, this.documentData);
            this.rotatePage('clockwise');
         }
      });

      documentViewer.addEventListener('pageComplete', async () => {

         document.getElementById('app-loader').style.display = 'flex';
         if (this.pageCounted !== documentViewer.getPageCount()) {
            this.setSaveBtn();
            this.isCheckHideSaveBtnDoc = true;
            this.isCloseBtnOnBack = false;
         }

         const pageSize = Number(documentViewer.getPageCount());
         if (pageSize === 1) {
            UI.disableElements(['thumbMultiDelete', 'thumbDelete', 'deletePage']);
         } else if (!this.isStartFlow) {
            if (!this.isCheckViewOnly && !this.isCheckComment) {
               UI.enableElements(['thumbMultiDelete', 'thumbDelete', 'deletePage']);
            }
         }

         if (this.isCheckHideSaveBtnDocLine || this.isRotatedLine) {
            UI.disableElements(['annotationNoteConnectorLine']);
         } else {
            UI.enableElements(['annotationNoteConnectorLine']);
         }
         this.isCheckHideSaveBtnDocLine = false;
         this.isRotatedLine = false;
         this.loader.hide();
         document.getElementById('app-loader').style.display = 'none';
      });

      annotMana.addEventListener(
         'annotationChanged',
         async (
            annotations: [Core.Annotations.Annotation],
            action: 'add' | 'modify' | 'delete',
            { imported }: Core.AnnotationManager.AnnotationChangedInfoObject
         ) => {
            this.genComment();
            if (this.flagCheckFirst) {
               this.firstAnnotationSize = annotations.length;
               this.checkAnnotationSize = this.firstAnnotationSize;
               this.isActionCount = this.count;
               this.flagCheckFirst = false;
            }
            if (!imported) {
               if (this.firstTimeCountAnno === 0 && annotMana.getAnnotationsList().length === 0) {
                  imported = true;
                  this.flagAnno = true;
               } else {
                  imported = false;
                  this.flagAnno = false;
               }
                if (this.flagAnno) {
                  imported = this.firstAnnotationSize === annotMana.getAnnotationsList().length;
               }
            }
            if (!imported) {
               this.count++;
               if (this.isActionCount !== this.count) {
                  this.genComment();
                  if (action === 'add') {
                     this.countComment++;
                     this.checkActionAdd = true;
                  }
                  if (this.documentData.actionType === 'switch') {
                     this.webViewerInstance?.UI.enableElements([this.Buttons["Save"].dataElement]);
                     localStorage.setItem('onChanged', 'true');
                     this.isShowSaveBtn = true;
                  }
                  this.isCheckHideSaveBtnXml = true;
                  this.isCloseBtnOnBack = false;
                  this.checkAnnotationSize++;
                  this.setSaveBtn();
               }
            }
            if (action === 'add' && !imported) {
               const annotationManager = Core.annotationManager;
               const annots =  annotationManager.getAnnotationsList();
               annots.forEach(a => {
                  annotationManager.showAnnotation(a);
                  annotationManager.redrawAnnotation(a);
               });
               instance.Core.documentViewer.refreshAll();    
            }
         }
      );

      documentViewer.addEventListener('displayModeUpdated', () => {
         this.annotationList = annotMana.getAnnotationsList();
         if (this.annotationList !== undefined) {
            this.genComment();
         }
      });

      documentViewer.addEventListener('annotationsLoaded', () => {
         // all annotations are available
         this.annotationList = annotMana.getAnnotationsList();
         if (this.annotationList !== undefined) {
            this.genComment();
         }
      });

      documentViewer.addEventListener('pagesUpdated', () => {
         if (this.rotationUpdated) {
            this.reLoadPage(UI, this.documentData);
         } else {
            this.checkAnnotationSize++;
            this.genComment();
            this.isCloseBtnOnBack = false;
            this.isRotated = true;
            this.genFileDoc(this.webViewerInstance).then(() => {});
            this.isRotatedLine = true;
            this.checkRotated = true;
            UI?.enableElements([this.Buttons["Save"].dataElement]);
            localStorage.setItem('onChanged', 'true');
            this.setSaveBtn();
         }
      });

      documentViewer.addEventListener('rotationUpdated', () => {
         this.rotationUpdated = true;
         UI?.disableElements([this.Buttons["Save"].dataElement]);
      });

      /**
       * Event to detect when switching theme mode with PDFTrons `UI.setTheme()`
       *
       * This code is written specifically for when user changing theme via WebViewer's
       * built-in setting menu: 'Settings > General > Theme'
       * Changing theme this way will NOT update icon of custom button.
       *
       * Thus, we need to detect 'themeChanged' event and manually update the icon.
       * =============================================================================
       * For some unknown reason, using addEventListener from documentViewer doesn't work.
       *    `documentViewer.addEventListener('themeChanged', () => {
       *       ...
       *    });`
       *
       * Thus, I add addEventListener to iframe instead.
       * =============================================================================
       * Note: UI.setTheme() fires 'themeChanged' event BEFORE finishing changing the theme.
       * Thus, be careful of default theme CSS style of PDFTron overwriting our custom CSS style.
       */
      instance.UI.iframeWindow.addEventListener('themeChanged', (theme: CustomEvent<unknown>) => {
         this.annoService.updateIconPathsForTheme(theme.detail as ThemeMode);
         this.updateButtonTheme();
      });

   } // End setInstanceFactory()

   //=============================================================================
   // WEB-VIEWER CONFIGURATION METHODS
   //=============================================================================

   /**
    * This function takes the mime type of document as input, checks if it is a
    * valid type for adding a page, and returns a boolean value indicating whether
    * the document can have a page added or not.
    * @param mimeType
    * @returns
    */
   private isMimeTypeCompatibleForAddPage(mimeType: string): boolean {
      const compatibleMimeType = new Set([
         'application/msword',
         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
         'image/jpeg',
         'image/png',
         'application/pdf',
         'application/vnd.ms-powerpoint',
         'application/vnd.openxmlformats-officedocument.presentationml.presentation',
         'image/tiff',
         'image/tif',
         'application/vnd.ms-excel',
         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
         'application/vnd.oasis.opendocument.text'
      ]);
      return compatibleMimeType.has(mimeType);
   }

   private isMimeTypeCompatibleForAddTemplate(mimeType: string): boolean {
      const compatibleMimeType = new Set([
         'application/pdf',
      ]);
      return compatibleMimeType.has(mimeType);
   }

   private setViewOnly(ins: WebViewerInstance) {
      this.isCheckViewOnly = true;
      const applyViewOnlySettings = () => {
         ins?.Core.annotationManager.enableReadOnlyMode();
         ins.UI.setToolMode('Pan');
         this.hideFunctions(ins);
         ins?.UI.disableElements(['toolbarGroup-Annotate', 'toolbarGroup-Sharp', 'selectToolButton', 'panToolButton', 'viewControlsButton',
            'outlinesPanelButton', 'toolsHeader', 'annotationPopup']);
      };

      ins?.UI.addEventListener?.('viewerLoaded', () => {
         applyViewOnlySettings();
      });

      ins?.UI.addEventListener?.('documentLoaded', () => {
         setTimeout(() => {
            applyViewOnlySettings();
         }, 100);
      });

      // Fallback: apply immediately in case events don't fire
      setTimeout(() => {
         applyViewOnlySettings();
      }, 500);
   }
   private unViewOnly(ins: WebViewerInstance) {
      this.isCheckViewOnly = false;
      ins?.Core.annotationManager.disableReadOnlyMode();
      this.showFunctions(ins);
      ins?.UI.enableElements(['toolbarGroup-Annotate', 'selectToolButton', 'panToolButton', 'viewControlsButton',
         'outlinesPanelButton', 'toolsHeader', 'annotationPopup']);
   }
   private showFunctions(ins: WebViewerInstance) {
      ins?.UI.enableElements(['highlightToolGroupButton', 'underlineToolGroupButton', 'strikeoutToolGroupButton',
         'squigglyToolGroupButton', 'freeTextToolGroupButton', 'shapeToolGroupButton', 'freeHandToolGroupButton',
         'toolbarGroup-Shapes', 'ellipseToolGroupButton', 'polygonToolGroupButton', 'polygonCloudToolGroupButton',
         'lineToolGroupButton', 'polyLineToolGroupButton', 'arrowToolGroupButton',
         'toolbarGroup-Insert', 'rubberStampToolGroupButton', 'stampToolGroupButton', 'fileAttachmentToolGroupButton',
         'calloutToolGroupButton',
         'toolbarGroup-Edit', 'startFormEditingToolGroupButton', 'cropToolGroupButton',
         'thumbRotateCounterClockwise', 'thumbRotateClockwise', 'thumbMultiRotate', 'thumbExtract',
         'undoButton', 'redoButton', 'eraserToolButton',
         'thumbMultiDelete', 'thumbDelete', 'documentControl', 'viewControlsDivider1', 'rotateHeader', 'rotateClockwiseButton',
         'rotateCounterClockwiseButton','leftPanelButton','leftPanel','insertFileButton', 'addPageButton', 'addTemplateButton']);
      ins?.UI.enableElements(['highlightToolButton', 'highlightToolButton2', 'highlightToolButton3', 'highlightToolButton4']);
      ins?.UI.enableElements(['underlineToolButton', 'underlineToolButton2', 'underlineToolButton3', 'underlineToolButton4']);
      ins?.UI.enableElements(['strikeoutToolButton', 'strikeoutToolButton2', 'strikeoutToolButton3', 'strikeoutToolButton4']);
      ins?.UI.enableElements(['squigglyToolButton', 'squigglyToolButton2', 'squigglyToolButton3', 'squigglyToolButton4']);
      ins?.UI.enableElements(['freeTextToolButton', 'freeTextToolButton2', 'freeTextToolButton3', 'freeTextToolButton4']);
      ins?.UI.enableElements(['rectangleToolButton', 'rectangleToolButton2', 'rectangleToolButton3', 'rectangleToolButton4']);
      ins?.UI.enableElements(['freeHandToolButton', 'freeHandToolButton2', 'freeHandToolButton3', 'freeHandToolButton4']);
      ins?.UI.enableElements(['toolbarGroup-EditText', 'toolbarGroup-FillAndSign', 'toolbarGroup-Forms', 'freeHandHighlightToolGroupButton', 'pageManipulationOverlayButton']);
      ins?.UI.enableElements(['downloadButton', 'printButton', 'fullscreenButton', 'signaturePanelButton',
         'themeChangeButton', 'commentsPrintOption', 'applyWatermark']);
   }
   /**
    * Disabling PDFTrons DOM elements (toolbars, buttons, etc.),
    * but not their related functions.
    */
   private hideFunctions(ins: WebViewerInstance) {
      ins?.UI.disableElements(['highlightToolGroupButton', 'underlineToolGroupButton', 'strikeoutToolGroupButton',
         'squigglyToolGroupButton', 'freeTextToolGroupButton', 'shapeToolGroupButton', 'freeHandToolGroupButton',
         'toolbarGroup-Shapes', 'ellipseToolGroupButton', 'polygonToolGroupButton', 'polygonCloudToolGroupButton',
         'lineToolGroupButton', 'polyLineToolGroupButton', 'arrowToolGroupButton',
         'toolbarGroup-Insert', 'rubberStampToolGroupButton', 'stampToolGroupButton', 'fileAttachmentToolGroupButton',
         'calloutToolGroupButton',
         'toolbarGroup-Edit', 'startFormEditingToolGroupButton', 'cropToolGroupButton',
         'thumbRotateCounterClockwise', 'thumbRotateClockwise', 'thumbMultiRotate', 'thumbExtract',
         'undoButton', 'redoButton', 'eraserToolButton',
         'thumbMultiDelete', 'thumbDelete', 'documentControl', 'viewControlsDivider1', 'rotateHeader', 'rotateClockwiseButton',
         'rotateCounterClockwiseButton','leftPanelButton','leftPanel','insertFileButton', 'addPageButton', 'addTemplateButton']);
      ins?.UI.disableElements(['highlightToolButton', 'highlightToolButton2', 'highlightToolButton3', 'highlightToolButton4']);
      ins?.UI.disableElements(['underlineToolButton', 'underlineToolButton2', 'underlineToolButton3', 'underlineToolButton4']);
      ins?.UI.disableElements(['strikeoutToolButton', 'strikeoutToolButton2', 'strikeoutToolButton3', 'strikeoutToolButton4']);
      ins?.UI.disableElements(['squigglyToolButton', 'squigglyToolButton2', 'squigglyToolButton3', 'squigglyToolButton4']);
      ins?.UI.disableElements(['freeTextToolButton', 'freeTextToolButton2', 'freeTextToolButton3', 'freeTextToolButton4']);
      ins?.UI.disableElements(['rectangleToolButton', 'rectangleToolButton2', 'rectangleToolButton3', 'rectangleToolButton4']);
      ins?.UI.disableElements(['freeHandToolButton', 'freeHandToolButton2', 'freeHandToolButton3', 'freeHandToolButton4']);
      ins?.UI.disableElements(['toolbarGroup-EditText', 'toolbarGroup-FillAndSign', 'toolbarGroup-Forms', 'freeHandHighlightToolGroupButton', 'pageManipulationOverlayButton']);
      ins?.UI.disableElements(['downloadButton', 'printButton', 'fullscreenButton', 'signaturePanelButton',
         'themeChangeButton', 'commentsPrintOption', 'applyWatermark']);
   }

   //=============================================================================
   // CUSTOM BUTTONS IN WEB-VIEWER'S MENU OVERLAY AND MENU BAR
   //=============================================================================

   private Buttons: { [ButtonName: string]: ActionButton } = {
      ToggleNotes: {
         type: 'actionButton',
         className: 'row',
         img: "icon-header-chat-line",
         onClick: () => {
            this.webViewerInstance?.UI.toggleElementVisibility('notesPanel');
            this.annoService.updateNotesPanelVisibilityStatus();
         },
         title: this.annoService.getLang('Notes'),
         dataElement: 'toggleNotesButton',
      },
      Print: {
         type: "actionButton",
         className: "row",
         img: this.annoService.printIcon,
         onClick: () => {
            this.annoService.printDoc();
         },
         dataElement: "alertButton",
         label: this.annoService.getLang('Print'),
         role: "option",
      },
      Download: {
         type: 'actionButton',
         className: 'row',
         img: this.annoService.downloadIcon,
         onClick: async () => {
            this.annoService.downloadDoc();
         },
         dataElement: 'alertButton',
         label: this.annoService.getLang('Download'),
         role: 'option'
      },
      ChangeThemeMode: {
         type: 'actionButton',
         className: 'row',
         img: this.annoService.themeIcon,
         onClick: async () => {
            this.annoService.switchThemeMode();
            this.updateButtonTheme();
         },
         dataElement: 'changeThemeModeButton',
         label: this.annoService.getLang(this.annoService.themeLabel),
         role: 'option'
      },
      InsertFile: {
         type: "actionButton",
         img: this.annoService.insertFileIcon,
         onClick: async () => {
            this.annoService.insertFile();
         },
         dataElement: "insertFileButton",
         title: this.annoService.getLang('InsertFile'),
      },
      AddPage: {
         type: "actionButton",
         img: this.annoService.addPageIcon,
         onClick: async () => {
            this.isCheckHideSaveBtnDoc = true;
            this.isCloseBtnOnBack = false;
            this.isSaveDoc = true;
            this.setSaveBtn();
            const documentViewer = this.webViewerInstance?.Core.documentViewer;
            const doc = documentViewer.getDocument();
            const width = documentViewer.getPageWidth(documentViewer.getPageCount());
            const height = documentViewer.getPageHeight(documentViewer.getPageCount());
            const lastPageCount = documentViewer.getPageCount();
            await doc.insertBlankPages([lastPageCount + 1], width, height);
         },
         dataElement: "addPageButton",
         title: this.annoService.getLang('AddPage'),
      },
      Save: {
         type: 'actionButton',
         img: this.annoService.saveIcon,
         onClick: async () => {
            if (document.getElementById('app-loader')) {
               document.getElementById('app-loader').style.display = 'flex';
               this.loading = true;
            }
            await this.saveChanges();
            // Note: saveChanges() only kicks off the upload; it does not await
            // its completion. The loader is hidden later in uploadCallback.complete()
            // once the upload actually finishes (and, for the create-task flow,
            // right before navigating away) — see ZE-6361.
         },
         dataElement: 'saveButton',
         title: this.annoService.getLang('SaveToPDF'),
      },
      Switch: {
         type: 'actionButton',
         img: this.annoService.switchViewIcon,
         onClick: async () => {
            await this.switchView();
         },
         dataElement: 'switchButton',
         title: this.annoService.getLang('SwitchView'),
      },
      AddTemplate: {
         type: "actionButton",
         img: this.annoService.addTemplateIcon,
         onClick: async () => {
            this.zone.run(async () => {
               await this.addTemplate();
            });
         },
         dataElement: "addTemplateButton",
         title: this.annoService.getLang('AddTemplate'),
      },
   };

   private updateButtonTheme() {
      this.Buttons["Print"].img = this.annoService.printIcon;
      this.Buttons["Print"].label = this.annoService.getLang('Print');
      this.Buttons["Download"].img = this.annoService.downloadIcon;
      this.Buttons["Download"].label = this.annoService.getLang('Download');
      this.Buttons["ChangeThemeMode"].img = this.annoService.themeIcon;
      this.Buttons["ChangeThemeMode"].label = this.annoService.getLang(this.annoService.themeLabel);
      this.webViewerInstance?.UI.settingsMenuOverlay.update(this.MenuOverlay);

      this.Buttons["InsertFile"].img = this.annoService.insertFileIcon;
      this.Buttons["AddPage"].img = this.annoService.addPageIcon;
      this.Buttons["Save"].img = this.annoService.saveIcon;
      this.Buttons["Switch"].img = this.annoService.switchViewIcon;
      this.Buttons["AddTemplate"].img = this.annoService.addTemplateIcon;

      this.webViewerInstance?.UI.setHeaderItems(() => {});
   }

   private hideLastDividerInMenuOverlay() {
      //| PDFTron automatically inject a divider and a 'settingsButton' to the end of Menu Overlay.
      //| 'settingsButton' is already disabled in webViewerOptions, but the divider is still there.
      //| Thus, we need to hide the divider.
      //|
      //| PDFTron doesn't provide easy API to hide the divider, so we need to do it manually.

      const iframePDFTron = document.querySelector('iframe').contentDocument;

      // Define a callback function to execute when mutations are observed
      const callback: MutationCallback = function(mutationsList: MutationRecord[]) {
         for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                  let lastDivider = iframePDFTron?.querySelector<HTMLElement>("div[data-element='menuOverlay'] .divider:last-child");
                  if (lastDivider) {
                     lastDivider.style.display = 'none';
                  }
            }
         }
      };

      // Disconnect the previous observer if it exists (to prevent memory leak), then create a new one
      this.lastDividerObserver?.disconnect();
      this.lastDividerObserver = new MutationObserver(callback);

      // Start observing the iframe with the configured parameters
      if (iframePDFTron) {
         this.lastDividerObserver?.observe(iframePDFTron.body, { childList: true, subtree: true });
      }
   }

   private pushCustomButtonsToHeader(header: UI.Header) {
      header.getHeader("toolbarGroup-Insert").delete("signatureToolGroupButton");

      // Replace the default toggleNotesPanel button with our custom toggleNotesPanel button (with onClick callback)
      header.getHeader("default").delete("toggleNotesButton");
      header.getHeader("default").get("searchButton").insertAfter(this.Buttons["ToggleNotes"]);
      if (this.documentData.actionType === 'switch') {
         header.getHeader("default").push(this.Buttons["Switch"]);
      }
      if (this.documentData.actionType === 'switchTask') {
         header.getHeader("default").push(this.Buttons["Switch"]);
      }
      header.getHeader("default").push(this.Buttons["InsertFile"]);
      header.getHeader("default").push(this.Buttons["AddPage"]);
      header.getHeader("default").push(this.Buttons["AddTemplate"]);

      const { UI } = this.webViewerInstance;
      if (this.showAddPageBtn) {
         UI?.enableElements([this.Buttons["InsertFile"].dataElement, this.Buttons["AddPage"].dataElement, this.Buttons["AddTemplate"].dataElement]);
      }
      else {
         UI?.disableElements([this.Buttons["InsertFile"].dataElement, this.Buttons["AddPage"].dataElement, this.Buttons["AddTemplate"].dataElement]);
      }

      if (this.showAddTemplateBtn) {
         UI?.enableElements([this.Buttons["AddTemplate"].dataElement]);
      }
      else {
         UI?.disableElements([this.Buttons["AddTemplate"].dataElement]);
      }

      if (!this.isCheckViewOnly) {
         header.getHeader("default").push(this.Buttons["Save"]);
      }

      if (this.isShowSaveBtn) {
         UI?.enableElements([this.Buttons["Save"].dataElement]);
         localStorage.setItem('onChanged', 'true');
      }
      else {
         UI?.disableElements([this.Buttons["Save"].dataElement]);
      }
   }

   //=============================================================================
   // ROTATE SELECTED PAGES OR A CURRENT PAGE
   //=============================================================================

   rotatePage(action: 'clockwise' | 'counterClockwise') {

      this.annoService.rotatePage(action);
      this.isCloseBtnOnBack = false;
      this.isRotated = true;
      this.isRotatedLine = true;
      this.setSaveBtn();

   }

   //=============================================================================
   // DELETE SELECTED PAGES OR A CURRENT PAGE
   //=============================================================================

   deletePage() {
      this.zone.run(() => {
         let selectedPage = this.webViewerInstance?.UI.ThumbnailsPanel.getSelectedPageNumbers();
         if (selectedPage.length > 0) {
            this.deletingPage(selectedPage);
         } else if (selectedPage.length === 0) {
               selectedPage = [this.webViewerInstance?.Core.documentViewer.getCurrentPage()];
               this.deletingPage(selectedPage);
            }
      });
   }

   private deletingPage(selectedPage: number[]) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
       this.translate.get('save-success').subscribe(s => {
           dialogRef.componentInstance.messageWarning = s;
       });
      dialogRef.afterClosed().subscribe(result => {
         if (result && selectedPage.length > 0) {
            this.loader.show();
            const doc = this.webViewerInstance?.Core.documentViewer.getDocument();
            doc.removePages(selectedPage).then(() => {});
            this.isCloseBtnOnBack = false;
            this.isCheckHideSaveBtnDoc = true;
            this.isCheckHideSaveBtnDocLine = true;
            this.setSaveBtn();
         }
      });
   }

   //=============================================================================
   // COMMENT
   //=============================================================================

   genComment() {
      if (this.annotationList.length === 0) {
         this.annotationList = this.webViewerInstance?.Core.documentViewer.getAnnotationManager().getAnnotationsList();
      } else {
         this.annotationList.forEach((annotation: any, i: number) => {
            this.firstCommentAnno[i] = annotation.pV;
            if (annotation.wta !== '' && annotation.wta !== undefined) {
               this.allCommentAnno[i] = { name: annotation.pV, comment: annotation.wta };
               if (this.checkFlagComment) {
                  this.checkCommentFirst++;
               }
            }
         });

         this.checkFlagComment = false;
      }
      if (this.checkFirstTime) {
         this.firstTimeCountAnno = this.annotationList.length;
         this.checkFirstTime = false;
      }
   }

   callNotify() {
      if (!this.checkEmpty(this.allCommentAnno)) {
         for (const length in this.allCommentAnno) {
            this.copyAllCommentAnno[length] = this.allCommentAnno[length].comment;
         }
      }

      if (!this.checkEmpty(this.firstCommentAnno)) {
         for (const length in this.firstCommentAnno) {
            this.copyFirstCommentName[length] = this.firstCommentAnno[length];
         }
      }
      this.genMessage(this.copyFirstCommentName, this.copyAllCommentAnno);
   }

   checkEmpty(data: { hasOwnProperty?: any; }) {
      for (const prop in data) {
         if (data?.hasOwnProperty(prop)) {
            return false;
         }
      }
      return JSON.stringify(data) === JSON.stringify({});
   }

   genMessage(copyAllCommentName: any[], copyAllCommentAnno: any[]) {
      for (const element of copyAllCommentAnno) {
         if (element !== '' && element !== undefined) {
            this.countComment++;
         }
      }

      if (
         this.countComment === this.checkCommentFirst ||
         copyAllCommentAnno.length === 0 ||
         copyAllCommentName.length === 0
      ) {
         return;
      } else {
         let email = '';
         const counting = {};
         copyAllCommentName.forEach(function (str) {
            counting[str] = (counting[str] || 0) + 1;
         });
         /** แจ้งเตือนในเคส dms ที่เป็น annotation แจ้งเจ้าของ anno*/
         if (Object.keys(counting).length !== copyAllCommentName.length) {
            let str: string;
            for (str in counting) {
               email = str.split('(')[1].split(')')[0];
               if (this.service.user.email !== email) {
                  this.service.notifyDocInfo(this.documentData.docId, this.documentData.fileName, this.service.user.name, email).subscribe(() => { });
               }
            }
         }
         /** กรณีมี comment จะส่งแจ้งเตือนแค่ เจ้าของเอกสาร ในเคส shared*/
         if (copyAllCommentAnno.length !== 0) {
            this.service.notifyDocInfo(this.documentData.docId, this.documentData.fileName, this.service.user.name, this.documentData.owner).subscribe(() => {});
         }
      }

   }

   //=============================================================================
   // SAVE FILE METHODS
   //=============================================================================

   /**
    * Subscribable Subject (Observable-like) that fires when this annotation-controller component finishes saving doc.
    *
    * Currently implement for only 'save & quit' but not 'clicking save button'.
    */
   safeToExit$: Subject<boolean>;

   private uploadCallbackDoc = {
      init: () => { },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: () => { },
      complete: () => {
         this.translate.get('save-success').subscribe(s => {
            this.toast.success(s);
            if (this.isSaveDoc === true || this.isUpdate === true) {
               this.fileUpload = this.fileXml;
               this.uploadDoc(this.service, this.documentData, this.router);
            }
         });
      }
   };

   private uploadCallback = {
      complete: () => {
         if (this.isCheckSaveOnBack) {
            if (!this.isTask) {
               localStorage.removeItem('url');
            }
            this.translate.get('save-success').subscribe(s => {
               if (this.documentData.actionType !== 'switch') {
                  if (!this.flagNoMsg) {
                     this.toast.success(s);
                  }
                  if (this.isNavigateToCreateTask && typeof this.callbackCreateTask === 'function') {
                        this.flagNoMsg = true;
                  }
                  UI?.disableElements([this.Buttons["Save"].dataElement]);
                  setTimeout(() => {
                     this.loader.hide();
                     if (document.getElementById('app-loader')) {
                        document.getElementById('app-loader').style.display = 'none';
                        this.loading = false;
                     }
                     if (this.isNavigateToCreateTask && typeof this.callbackCreateTask === 'function') {
                        this.flagNoMsg = true;
                        this.callbackCreateTask();
                        this.isNavigateToCreateTask = false;
                     } else if (!this.isCreateTask) {
                        window.location.reload();
                     } else {
                        this.isCreateTask = false;
                        this.flagNoMsg = false;
                     }
                  }, 1000);
               } else {
                  this.isCheckSaveOnBack = false;
                  this.isCheckSaveBtn = false;
                  this.checkSaveOnStartFlow = true;
                  this.fileUpload = this.fileMerge;
                  this.uploadDocToTemp(this.service, this.fileUpload,this.documentData.docId, this.zone, this.switchViewer, this.checkSaveOnStartFlow);
                  UI?.disableElements([this.Buttons["Save"].dataElement]);
                  this.loader.hide();
                  if (document.getElementById('app-loader')) {
                     document.getElementById('app-loader').style.display = 'none';
                     this.loading = false;
                  }
               }
            });
         }
         if (this.isCheckSaveBtn) {
            this.translate.get('save-success').subscribe(s => {
               if (this.documentData.actionType === 'switch') {
                  this.isShowSaveBtn = false;
                  this.fileUpload = this.fileMerge;
                  this.checkSaveOnStartFlow = false;
                  this.uploadDocToTemp(this.service, this.fileUpload,this.documentData.docId, this.zone, this.switchViewer, this.checkSaveOnStartFlow);
                  this.webViewerInstance?.UI.disableElements([this.Buttons["Save"].dataElement]);
                  this.toast.success(s);
                  this.loader.hide();
                  if (document.getElementById('app-loader')) {
                     document.getElementById('app-loader').style.display = 'none';
                     this.loading = false;
                  }

               } else {
                  this.toast.success(s);
                  UI?.disableElements([this.Buttons["Save"].dataElement]);
                  setTimeout(() => {
                     if (document.getElementById('app-loader')) {
                        document.getElementById('app-loader').style.display = 'none';
                        this.loading = false;
                     }
                     window.location.reload();
                  }, 1000);
                  this.loader.hide();
               }

            });
         }
      }
   };

   private roundCount = 0;
   setSaveBtn() {
      if (!this.isStartFlow) {
         // Add a save button on header
         if (this.isCheckHideSaveBtnXml || this.isCheckHideSaveBtnDoc || this.isRotated) {
            this.roundCount++;
            if (this.roundCount <= 1) {
               this.isShowSaveBtn = true;
               this.webViewerInstance?.UI?.enableElements([this.Buttons["Save"].dataElement]);
               localStorage.setItem('onChanged', 'true');
            }
         }
      } else {
         // ในกรณี start flow ไปแล้ว
         this.isCheckHideSaveBtnXml = false;
         this.isCheckHideSaveBtnDoc = false;
         this.isRotated = false;
         this.setViewOnly(this.webViewerInstance);
      }
   }


   async genFileXml(ins: WebViewerInstance) {
      this.flagOpenDialog = false;
      if (isSaveAnnotation) {
         this.fileXml = await this.annoService.genFileXml(ins);
      } else {
         this.fileMerge = await this.annoService.genFileMerge(ins);
      }
      if (this.documentData.actionType === 'switch') {
         this.fileMerge = await this.annoService.genFileMerge(ins);
      }
   }

   async genFileDoc(ins: WebViewerInstance) {
      if (isSaveAnnotation) {
         this.fileDocs = await this.annoService.genFileDoc(this.webViewerInstance, this.isCheckHideSaveBtnDoc, this.isRotated);
      }
      if (this.documentData.actionType === 'switch') {
         this.fileMerge = await this.annoService.genFileMerge(ins);
      }
   }

   /**
    * Prompts the user a dialog asking to save any unsaved changes before exiting the application.
    *
    * It returns whether it is safe to exit the application or not.
    *
    * @returns {boolean | Subject<boolean>} true if it is safe to exit, false otherwise
   */
   handleUnsavedChangesOnExit(): boolean | Subject<boolean> {
      if (!this.closePage()) return true;

      this.safeToExit$ = new Subject();
      this.unsaveTemplate$ = new Subject();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
         disableClose: true,
         data: this
      });
      this.translate.get('viewer.confirmTitle').subscribe(s => {
         dialogRef.componentInstance.messageWarning = s;
         dialogRef.componentInstance.isSaved = true;
      });
      this.translate.get('viewer.saveInfo').subscribe(s => {
         dialogRef.componentInstance.messageInfo = s;
         dialogRef.componentInstance.isShowInfo = true;
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const str = dialogRef.componentInstance.str.toString();
            if (str === 'ok') {
               // Save
               if (this.documentData.actionType === 'switch') {
                  this.webViewerInstance?.UI.disableElements([this.Buttons["Save"].dataElement]);
                  this.isShowSaveBtn = false;
                  this.saveDoc = true;
               }
               this.saveChangesOnExit().then(() => {
                  this.safeToExit$.next(true);
                  this.safeToExit$.complete();
                  this.unsaveTemplate$.next('ok');
                  this.unsaveTemplate$.complete();
               })
            }
            else {
               // Don't Save
               if (this.documentData.actionType === 'switch') {
                  this.webViewerInstance?.UI.disableElements([this.Buttons["Save"].dataElement]);
                  this.isShowSaveBtn = false;
                  this.webViewerInstance?.UI.dispose().then(() => {});
                  this.webViewerInstance?.UI.loadDocument(this.documentData.url, {
                     filename: this.documentData.fileName,
                     documentId: '1',
                  });
                  this.switchViewer.emit('notSave');
               }
               this.safeToExit$.next(true);
               this.safeToExit$.complete();
               this.unsaveTemplate$.next('unsave');
               this.unsaveTemplate$.complete();
               if (!this.isTask) {
                  localStorage.removeItem('url');
               }
               this.isNavigateToCreateTask = false;
            }
         }
         else {
            // Cancel
            this.isNavigateToCreateTask = false;
            this.safeToExit$.next(false);
            this.safeToExit$.complete();
            this.unsaveTemplate$.next('cancel');
            this.unsaveTemplate$.complete();
         }
      });
      return this.safeToExit$;
   }

   /**
    * Save file. Call when 'Save' before navigating away.
    */
   async saveChangesOnExit() {
      this.isCheckSaveOnBack = true;
      // The overlay is only drawn after loader.show(); changing the display of #app-loader alone shows nothing (ZE-6361).
      // It is hidden in uploadCallback.complete() once the upload has finished.
      this.loader.show();
      if (document.getElementById('app-loader')) {
         document.getElementById('app-loader').style.display = 'flex';
         this.loading = true;
      }
      return Promise.all([
      this.genFileXml(this.webViewerInstance),
      this.genFileDoc(this.webViewerInstance),
      ]).then(() => {
         if (!isSaveAnnotation) {
            this.fileUpload = this.fileMerge;
            this.isSaved(this.uploader, this.service, this.limitSize, this.documentData, this.router, this.uploadCallbackDoc);
            return;
         }
         if (this.saveDoc) {
            this.isSaveDoc = true;
            this.fileUpload = this.fileDocs;
            this.isSaved(this.uploader, this.service, this.limitSize, this.documentData, this.router, this.uploadCallbackDoc);
            this.webViewerInstance?.Core.documentViewer.refreshAll();
         }
         if (this.saveXml) {
            this.isUpdateOnClose = true;
            this.isUpdate = true;
            this.fileUpload = this.fileXml;
            this.uploadDoc(this.service, this.documentData, this.router);
            this.webViewerInstance?.Core.documentViewer.refreshAll();
         }
         if (!this.saveDoc && !this.saveXml) {
            // nothing is uploaded so uploadCallback.complete() will not hide the loader
            this.hideSaveLoader();
         }
      }).catch(error => {
         // generating the file failed, do not leave the full screen loader covering the page
         this.hideSaveLoader();
         throw error;
      });
   }

   private hideSaveLoader() {
      this.loader.hide();
      if (document.getElementById('app-loader')) {
         document.getElementById('app-loader').style.display = 'none';
      }
      this.loading = false;
   }

   /**
    * Save file. Call when 'Save' button is clicked.
    */
   async saveChanges() {
      this.loader.show();
      await this.genFileXml(this.webViewerInstance);
      await this.genFileDoc(this.webViewerInstance);
      if (!isSaveAnnotation) {
         this.isCloseBtnOnBack = true;
         this.isCheckSaveBtn = true;
         this.isCheckHideSaveBtnXml = false;
      }
      this.isActionCount = this.count;

      if (this.isCheckHideSaveBtnXml) {
         this.saveXml = true;
      }
      if (this.isCheckHideSaveBtnDoc || this.isRotated) {
         this.saveDocs = true;
      }
      if (this.documentData.actionType === 'switch') {
         this.saveDocs = true;
         this.saveXml = false;
      }

      if (!isSaveAnnotation) {
         this.fileUpload = this.fileMerge;
         this.isSaved(this.uploader, this.service, this.limitSize, this.documentData, this.router, this.uploadCallbackDoc);
         return;
      }
      if (this.saveDocs) {
         this.fileUpload = this.fileDocs;
         this.isSaveDoc = this.saveDocs;
         this.isSaved(this.uploader, this.service, this.limitSize, this.documentData, this.router, this.uploadCallbackDoc);
         this.webViewerInstance?.Core.documentViewer.refreshAll();
      }
      if (this.saveXml) {
         this.fileUpload = this.fileXml;
         this.isUpdate = true;
         this.uploadDoc(this.service, this.documentData, this.router);
         this.webViewerInstance?.Core.documentViewer.refreshAll();
      }
      if (this.checkActionAdd) {
         this.callNotify();
      }
      this.isCloseBtnOnBack = true;
      this.isCheckSaveBtn = true;
   }

   async switchView() {
      this.countSwitch++;
      if (this.isShowSaveBtn) {
         this.zone.run(() => {
            this.handleUnsavedChangesOnExit();
         });
      } else if (localStorage.getItem('newTempId') != null) {
            this.switchViewer.emit(localStorage.getItem('newTempId'));
            localStorage.removeItem('newTempId');
         } else {
            this.switchViewer.emit('notSave');
         }
   }

   async addTemplate(){
      const tin = localStorage.getItem('tin');
      this.service.getBusinessSiteBySiteCode(tin).subscribe(result => {
         if (result) {
               localStorage.setItem('tin', result.tin);
               localStorage.setItem('siteCode', result.siteCode);
               this.pdfTemplateListDialog = this.dialog.open(PdfTemplateListDialogComponent, {
                  disableClose: true,
                  data: this
               });
               this.pdfTemplateListDialog.componentInstance.fromPage = 'addTemplate';
               this.pdfTemplateListDialog.afterClosed().subscribe(async arrayBuffer => {
                  if (arrayBuffer) {
                     this.isCheckHideSaveBtnDoc = true;
                     this.isCloseBtnOnBack = false;
                     this.isSaveDoc = true;
                     this.setSaveBtn();
                     const templateDoc = await this.webViewerInstance?.Core.createDocument(arrayBuffer);
                     const documentViewer = this.webViewerInstance?.Core.documentViewer;
                     const doc = documentViewer.getDocument();
                     const currentPage = documentViewer.getCurrentPage();
                     const pageCount = templateDoc.getPageCount();
                     const allPages = Array.from({length: pageCount}, (_, i) => i + 1);
                     await doc.insertPages(templateDoc, allPages, currentPage + 1);
                  }
               });
            }        
      }, error => {
         this.toast.error('Failed to get business site information');
      });
   }

   ngOnDestroy() {
      this.lastDividerObserver?.disconnect();
      this.safeToExit$?.complete();
      this.unsaveTemplate$?.complete();
   }

   /**
    * เช็คว่าควรจะแสดง dialog เตือน unsaved change หรือไม่
    * (ฟังก์ชันนี้ถูกเรียกเมื่อมีการกดปุ่มย้อนกลับ)
    * @returns boolean ที่บอกว่าควรเปิด dialog เตือน user ว่าจะเซฟไฟล์ก่อนออกไหม?
    */
   closePage(): boolean {
      this.flagOpenDialog = false;
      // ConfirmDialog จะทำงานแค่ true เพราะ status false คือ ยังไม่ startFlow
      if (this.isStartFlow) {
         return false;
      }
      if (!this.isFlagCloseCanDe) {
         this.flagOpenDialog = false;
         return this.flagOpenDialog;
      }
      if (this.isCloseBtnOnBack) {
         return false;
      }
      if (this.isCheckHideSaveBtnXml) {
         this.saveXml = true;
         this.flagOpenDialog = true;
      }
      if (this.isCheckHideSaveBtnDoc || this.isRotated) {
         this.saveDoc = true;
         this.flagOpenDialog = true;
      }
      return this.flagOpenDialog;
   }

   private isSaved(uploader: FileUploader, service: IdexService, limitSize: number, documentData: DocumentData, router: Router, uploadCallbackDoc: AnnotationControllerComponent["uploadCallbackDoc"]) {
      if (isSaveAnnotation) {
         const path = documentData.path;
         const subPath = path.split('/', 2);
         if (this.documentData.actionType === 'switch') {
            uploader.uploadFiles([this.fileUpload], limitSize, subPath[1], null, uploadCallbackDoc, documentData.docId.toString(),'', false);
         } else {
            uploader.uploadFiles([this.fileUpload], limitSize, subPath[1], null, uploadCallbackDoc, documentData.docId.toString());
         }
      } else {
         this.uploadDoc(service, documentData, router);
      }
   }

   private uploadDoc(service: IdexService, documentData: DocumentData, router: Router) {
      this.initUploadDoc(1).subscribe(result => {
         const key = result.key;
         const fileNo = result.fileNo;
         let offset = 0;
         const xhr = new XMLHttpRequest();
         const send = () => {
            const end = Math.min(offset + this.chunkSize, this.fileUpload.size);
            xhr.open('PUT', service.url + '/upload/' + key, true);
            xhr.setRequestHeader('x-auth-token', service.user.token);
            xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + this.fileUpload.size);
            const blob = this.fileUpload.slice(offset, end);
            xhr.send(blob);

         };
         xhr.onload = () => {
            if (xhr.status === 308) {
               if (this.fileUpload.canceled) {
                  service.post('/cancel/upload/' + key, null).subscribe(() => { },
                     (err) => {
                        console.error(err);
                     });
                  return;
               }
               offset += this.chunkSize;
               send();
            } else if (xhr.status === 201) {
               if (isSaveAnnotation) {
                  this.handleFinishUploadDoc(key, '', this.fileUpload, '', fileNo, this.annotationId);
               } else {
                  this.handleFinishUploadDoc(key, '', this.fileUpload, '', fileNo, documentData.docId);
               }
            }
         };
         send();
      }, error => {
         this.fileUpload.error = error;
         this.loader.hide();
         if (document.getElementById('app-loader')) {
            document.getElementById('app-loader').style.display = 'none';
            this.loading = false;
         }
         if (error.status === 401) {
            this.zone.run(() => { router.navigate(['/login']).then(() => {}); });
         }
      });
   }

   private initUploadDoc(loopFile: string | number): Observable<any> {
      return this.service.get('/init/upload/' + loopFile);
   }

   private handleFinishUploadDoc(key: string, path: string, file: any, tin: string, loopFile: any, id?: string) {
      const body = {
         name: file.fullPath || file.name,
         destination: path,
         mimeType: file.type,
         tin: tin,
         id: id
      };
      body.name = decodeURIComponent(body.name);
      this.service.uploadDocumentTemp(this.typeName, body, loopFile, key).subscribe((response) => {
         if (isSaveAnnotation) {
            // ค้นหาก่อนว่ามี docId แล้วหรือยัง
            this.checkSaving(response);
         } else {
            this.zone.run(() => { this.uploadCallback.complete(); });
         }
      }, error => {
         if (error.status === 413) {
            file.error = error.message;
         }
         this.loader.hide();
         if (document.getElementById('app-loader')) {
            document.getElementById('app-loader').style.display = 'none';
            this.loading = false;
         }
         if (error.status === 401) {
            this.zone.run(() => { this.router.navigate(['/login']).then(() => {}); });
         }
      });
   }

   private checkSaving(response: any) {

      this.service.getAnnotation(this.documentData.docId, true).subscribe(async (annotation) => {
         if (this.isSaveDoc === true && this.isUpdate === true) {
            this.isInsert = true;
            if (annotation !== null) {
               this.isUpdate = false;
            } else {
               this.isUpdate = true;
            }
         } else if (this.isSaveDoc === false && this.isUpdate === true) {
            if (annotation === null) {
               this.isInsert = true;
            } else {
               this.isInsert = false;
               this.isUpdate = true;
            }
         } else if (this.isUpdate === true) {
            this.isInsert = true;
         }
         if (this.isSaveDoc === true && annotation !== null) {
            this.isInsert = true;
         }
         if (!this.annotationVersion) {
            this.annotationVersion = '1.0';
         } else {
            this.annotationVersion = (parseFloat(this.annotationVersion) + 1).toFixed(1);
         }
         if (this.documentData.actionType === 'switch') {
            this.isInsert = true;
            this.isUpdate = true;
         }
         if (this.isInsert) {
            // send data to service
            this.service.insertDataToDatabase(this.documentData.docId, response.docId, this.annotationVersion, this.createdBy)
               .subscribe(response => {
                  // reload page เพื่อ refresh update service get version
                  if (!this.isUpdateOnClose) {
                     if (response) {
                        this.zone.run(() => { this.uploadCallback.complete(); });
                        if (this.documentData.actionType !== 'switch') {
                           window.location.reload();
                        }
                        this.loader.hide();
                     }
                  }
               }, error => {
                  console.error(error);
               });
         } else {
            this.webViewerInstance?.UI.disableElements([this.Buttons["Save"].dataElement]);
            if (this.documentData.actionType !== 'switch') {
               window.location.reload();
            }
            this.loader.hide();
         }
         if (this.isUpdate) {
            this.service.upDateDataToDatabase(this.annotationVersion, this.documentData.docId, this.docAnnotationId, this.createdBy).subscribe(response => {
               if (!this.isUpdateOnClose) {
                  if (response) {
                     this.zone.run(() => { this.uploadCallback.complete(); });
                     if (this.documentData.actionType !== 'switch') {
                        window.location.reload();
                     }
                     this.loader.hide();
                  }
               }
            }, error => {
               console.error(error);
            });
         } else {
            this.webViewerInstance?.UI.disableElements([this.Buttons["Save"].dataElement]);
            if (this.documentData.actionType !== 'switch') {
               window.location.reload();
            }
            this.loader.hide();
         }

      });
   }

   //=============================================================================
   // CHECK USER TIMEOUT
   //=============================================================================

   private checkTimeOut() {
      setInterval(() => {
         if (this.firstAnnotationSize !== this.checkAnnotationSize) {
            this.firstAnnotationSize = this.checkAnnotationSize;
            this.service.getCheckTimeOut().subscribe(() => {
            }, error => {
               if (error.status === 401) {
                  this.isFlagCloseCanDe = false;
                  this.flagOpenDialog = false;
                  this.isCheckHideSaveBtnXml = false;
                  this.isCheckSaveOnBack = false;
                  this.isCheckHideSaveBtnDoc = false;
                  this.saveXml = false;
                  this.saveDocs = false;
                  this.isRotated = false;
                  this.zone.run(() => { this.router.navigate(['/login']).then(() => {}); });
               }
            });
         }
      }, 600000);
   }

   uploadDocToTemp(service: any, fileUpload: any, id: any, zone: any, switchViewer?: any, isSave?: boolean) {
      const chunkSize = 1048576;

      function init(loopFile: string | number): Observable<any> {
         return service.get('/init/upload/' + loopFile);
      }

      function finish(key: string, path: string, file: any, tin: string, loopFile: any, id?: string) {
         const body = {
            name: file.fullPath || file.name,
            destination: path,
            mimeType: file.type,
            tin: tin,
            id: ''
         };
         service.uploadDocumentTemp('temp', body, loopFile, key).subscribe((response: { docId: any; }) => {

            let docList = [];
            docList.push(response.docId);
            service.transformPdf(docList).subscribe((data: { docId: string; }[]) => {
               zone.run(() => {
                  localStorage.setItem('newTempId', data[0].docId+','+id);
                  if (isSave) {
                     switchViewer.emit(data[0].docId+','+id);
                  } else {
                     return;
                  }
               });
            });


         }, (error: { status: number; message: any; }) => {
            if (error.status === 413) {
               file.error = error.message;
            }
         });
      }

      init(1).subscribe(result => {
         const key = result.key;
         const fileNo = result.fileNo;
         let offset = 0;
         const xhr = new XMLHttpRequest();
         const send = () => {
            const end = Math.min(offset + chunkSize, fileUpload.size);
            xhr.open('PUT', service.url + '/upload/' + key, true);
            xhr.setRequestHeader('x-auth-token', service.user.token);
            xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + fileUpload.size);
            const blob = fileUpload.slice(offset, end);
            xhr.send(blob);

         };
         xhr.onload = () => {
            if (xhr.status === 308) {
               if (fileUpload.canceled) {
                  service.post('/cancel/upload/' + key, null).subscribe(() => { },
                     (err: any) => {
                        console.error(err);
                     });
                  return;
               }
               offset += chunkSize;
               send();
            } else if (xhr.status === 201) {
               finish(key, '', fileUpload, '', fileNo, id);
            }
         };
         send();
      }, error => {
         fileUpload.error = error;
      });
   }

   reLoadPage(UI: WebViewerInstance["UI"], documentData: DocumentData){
      this.checkRotated = true;
      if (this.rotationUpdated) {
         UI.loadDocument(documentData.url, { documentId: '1', filename: documentData.fileName });
         this.rotationUpdated = false;
      }
   }

   checkStatusViewOnly(instance: WebViewerInstance) {
      if ((!this.documentData.isPermissions || this.isStartFlow || !this.documentData.isPermissions.edit
         || this.documentData.statusDocument === 'Deleted') && this.documentData.actionType !== 'switch') {
         this.showAddPageBtn = false;
         this.showAddTemplateBtn = false;
         this.isCheckHideSaveBtnXml = false;
         this.isCheckHideSaveBtnDoc = false;
         this.isRotated = false;
         this.isCheckViewOnly = true;
         this.setViewOnly(instance);
      } else {
         this.unViewOnly(instance);
      }
   }
}

